import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'

import { getGamInventoryType, inventoryTypes, formatRightInventoryOptions } from '../../helpers'

import { rightSelector } from '../../../../../../../modules/selectors/rights'

import { TARGETING_OPTION, RIGHT_INVENTORY_SELECT, targetingOptions } from '../../fields'
import { AD_INVENTORY } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

const InventorySelectionRadioBlocks = ({ formik, allInventoryChildren, specificInventoryChildren }) => {
  const { t } = useTranslation()
  const right = useSelector(rightSelector)
  const { setFieldValue, values, errors, touched } = formik

  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  // Get available inventory from right.ad_inventory
  const inventoryOptions = useMemo(() => {
    return formatRightInventoryOptions(right[AD_INVENTORY])
  }, [right])

  const targetAllInventoryLabel = useMemo(() => {
    return inventoryType === inventoryTypes.placements ? 'Target all placements' : 'Target all ad units'
  }, [inventoryType])

  const targetSpecificInventoryLabel = useMemo(() => {
    return inventoryType === inventoryTypes.placements ? 'Target specific placements' : 'Target specific ad units'
  }, [inventoryType])

  const selectInventoryDescription = useMemo(() => {
    return inventoryType === inventoryTypes.placements
      ? 'Select placements to target this line item to'
      : 'Select ad units to target this line item to'
  }, [inventoryType])

  const inventoryFieldPlaceholder = useMemo(() => {
    return inventoryType === inventoryTypes.placements ? 'Select placements' : 'Select ad units'
  }, [inventoryType])

  return (
    <>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_target_all_inventory"
        name={TARGETING_OPTION}
        label={t(targetAllInventoryLabel)}
        value={targetingOptions.ALL_INVENTORY}
        selectedValue={values[TARGETING_OPTION]}
      >
        {allInventoryChildren}
      </RadioBlock>

      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_target_specific_inventory"
        name={TARGETING_OPTION}
        label={t(targetSpecificInventoryLabel)}
        value={targetingOptions.SPECIFIC_INVENTORY}
        selectedValue={values[TARGETING_OPTION]}
      >
        {specificInventoryChildren}

        <p>{t(selectInventoryDescription)}</p>

        <MultiSelectBox
          value={values[RIGHT_INVENTORY_SELECT]}
          name={RIGHT_INVENTORY_SELECT}
          setFieldValue={setFieldValue}
          options={inventoryOptions}
          placeholder={t(inventoryFieldPlaceholder)}
        />
        {errors[RIGHT_INVENTORY_SELECT] && touched[RIGHT_INVENTORY_SELECT] && (
          <ErrorMessage error={errors[RIGHT_INVENTORY_SELECT]} />
        )}
      </RadioBlock>
    </>
  )
}

export default InventorySelectionRadioBlocks
